import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import NumberFormat from "react-number-format";

const InputCurrencyS1 = ({
							className,
							label,
							readOnly,
							placeholder,
							type,
							size,
							field,
							disabled,
							isRequired,
							validate,
							value,
							prependData,
							onChange,
							...props
						}) => {

	const classes = cx(
		'form-field',
		`form-field--${size}`,
		disabled && `form-field--disabled`,
		value && 'form-field--active',
		className
	);

	return (
		<div className={classes}>
			{label && (
				<label className="form-field__label">
					{label}
					{isRequired && <span title={"Обязательный поля"}>*</span>}
				</label>
			)}
			<div className="input-group">
				<NumberFormat
					value={value}
					onValueChange={values => {
						onChange(values.value);
					}}
					thousandSeparator=" "
					isNumericString
					className={'form-field__input'}
					{...{placeholder, type}}
					{...props}
				/>

				{prependData && prependData}
			</div>
		</div>
	);
};

InputCurrencyS1.propTypes = {
	label: PropTypes.string,
	type: PropTypes.oneOf(["text", "password", "number"]),
	className: PropTypes.string,
	placeholder: PropTypes.string,
	readOnly: PropTypes.bool,
	size: PropTypes.oneOf(["default", "large", "small"]),
	disabled: PropTypes.bool,
	isRequired: PropTypes.bool,
};

InputCurrencyS1.defaultProps = {
	label: "",
	placeholder: "",
	type: "text",
	className: null,
	readOnly: false,
	disabled: false,
	isRequired: false,
	size: "default",
};

export default InputCurrencyS1;
